import React, { useState } from 'react';
import styles from './SiteHeader.module.scss';
import Text from '../../atoms/text/Text';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import LanguageToggle from '../../atoms/languageToggle/LanguageToggle';
import SideModal from '../../hoc/sideModel/SideModal';
import Navigator from '../../molecule/navigationBar/Navigator';
import useIsRtl from '../../../app/helpers/isRtl';
import { useDispatch, useSelector } from 'react-redux';
import RoutesData from '../../../routes/factory/routesData';
import { useTranslation } from 'react-i18next';
import {
  closeAllModals,
  toggleAccessModal,
  toggleNavigationBar,
} from '../../../app/globals/slice/sideModalSlice/SideModalSlice';
import { setVolume } from '../../../app/globals/slice/volume/VolumeState';
import { fontsData, navLinks, volumeData } from './factory/HeaderData';
import BoxButtonGroup from '../../molecule/boxButtonGroup/BoxButtonGroup';
import { setFontSize } from '../../../app/globals/slice/fontSizeSlice/FontSizeSlice';
import { SearchInput } from '../../atoms/searchInput/SearchInput';
import useNavigatorData from './factory/useNavigatorData';
import { useMediaQuery } from 'react-responsive';
import NavigationMobile from '../../molecule/navigationBar/mobile/NavigationMobile';
import SearchModal from '../../hoc/modal/search-modal/SearchModal';
import getCookie from '../../../app/helpers/getCookie';
import useDeafModeAutoMute from '../../../app/hooks/useDeafModeAutoMute';

const accessibilitySVG = '/assets/svg/header/Accessibility.svg';
const burgerMenuSVG = '/assets/svg/header/menu.svg';
const loginSvg = '/assets/svg/header/login.svg';
const academy360 = '/assets/svg/header/academy360.svg';
const logo = '/assets/svg/logo-svg/Layer_1-2.svg';
const dubaiLogo = '/assets/svg/logo-svg/dubaiPolice.svg';
const dubaiLogoColored = '/assets/svg/logo-svg/govtLogo-Colored.svg';
const logoLine = '/assets/svg/logo-svg/Vector.svg';
const dubaiLogoWhite = '/assets/svg/logo-svg/govLogo-white.svg';
const searchSvg = '/assets/svg/header/search.svg';
const exitSvg = '/assets/svg/exit.svg';
const useIsNormalHeader = () => {
  const { pathname } = useLocation();

  const isNewsPage =
    /^\/news-and-events(?:\/.*)?|^\/academy-eco-magazine(?:\/.*)?|^\/security-and-law(?:\/.*)?|^\/academic-research-and-publications(?:\/.*)?|^\/magazines(?:\/.*)?|^\/research\/guideline(?:\/.*)?$/.test(
      pathname
    );

  return !isNewsPage;
};
const SiteHeader = ({ isNormal, invisible, isHome }) => {
  useDeafModeAutoMute();
  const isEnglish = getCookie('googtrans')?.includes('/ar/en');

  const isTablet = useMediaQuery({ maxWidth: 1000 });
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isFixed = pathname === '/' || pathname === '/about/history';
  const onHome = pathname === '/';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isRtl = useIsRtl();

  const fontSize = useSelector((state) => state.fontSize);
  const degreeData = useSelector((state) => state.degreeData?.degreeData || []);
  const { navigationBar, access } = useSelector((state) => state.sideModal);
  const volume = useSelector((state) => state.volume);
  const [isSearchOpen, setSearchOpen] = useState(false);

  // if false white background UI, if true transparent background UI
  let isNormalHeader = useIsNormalHeader();

  if (isNormal) {
    isNormalHeader = false;
  }
  const [searchMobileToggle, setSearchMobileToggle] = useState(false);

  // injecting the degrees to the array for navigation
  const navigatorData = useNavigatorData(degreeData);

  const handleOpenNavigator = () => {
    dispatch(toggleNavigationBar());
  };

  const handleFontClick = (mode) => {
    dispatch(setFontSize(mode));
  };
  const handleVolume = (mode) => {
    dispatch(setVolume(mode));
  };

  // const handleAccessibility = (flag) => {
  //   dispatch(toggleAccessModal());
  // };
  const handleSearchClick = (flag) => {
    setSearchMobileToggle(flag);
  };
  if (onHome && !isHome) return null;

  return (
    <header
      className={`${styles['site-header']} ${isNormalHeader ? styles['inner-header'] : ''} ${isFixed ? styles['home-header'] : ''} ${!isNormalHeader ? styles['shadow'] : ''}`}
      style={{ display: invisible ? 'none' : '' }}
    >
      <div className={styles['logo-container']}>
        <a
          href="https://www.dubai.ae/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles['dubai-govLogo']}
        >
          <img
            src={isNormalHeader ? dubaiLogoWhite : dubaiLogoColored}
            alt="Dubai Government"
            decoding="async"
          />
        </a>

        <div
          className={styles['right-logo-container']}
          style={{ width: isTablet ? '100%' : '' }}
        >
          {isTablet && (
            <button
              className={`${styles['burger-button']} ${isRtl ? styles['order-3'] : styles['order-1']}`}
              onClick={handleOpenNavigator}
            >
              <img
                src={burgerMenuSVG}
                className={styles['burger']}
                alt="menu"
              />
            </button>
          )}

          <div
            className={`${styles['right-logo']} ${!isNormalHeader ? styles['green-logo'] : ''} ${styles['order-2']}`}
          >
            <NavLink to="/" aria-label="Dubai Police Home">
              <img src={logo} alt="Dubai Police Home" decoding="async" />
            </NavLink>
            <img
              src={logoLine}
              alt=""
              role="presentation"
              width={20}
              height={40}
              decoding="async"
            />
            <a
              href="https://www.dubaipolice.gov.ae/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={dubaiLogo} alt="Dubai Police" />
            </a>
          </div>

          {isTablet && (
            <button
              className={`${styles['burger-button']} ${isRtl ? styles['order-1'] : styles['order-3']}`}
              onClick={handleSearchClick}
            >
              <img
                src={searchSvg}
                className={styles['burger']}
                alt="Open search"
                width={24}
                height={24}
                decoding="async"
              />{' '}
            </button>
          )}
        </div>
      </div>
      <div
        className={`${styles['navigation-container']} ${isRtl ? styles['navigation-rtl'] : ''}`}
      >
        <div
          className={`${styles['nav-wrapper']} ${isRtl ? styles['navigation-rtl'] : ''}`}
        >
          <button
            className={styles['burger-button']}
            onClick={() => handleOpenNavigator()}
          >
            <img
              src={burgerMenuSVG}
              className={styles['burger']}
              alt="dubai police"
            />
          </button>

          <nav className={styles['navigation']} dir={isRtl ? 'rtl' : 'ltr'}>
            {navLinks.map(({ path, title, showOnHome = true }) => {
              if (onHome && path === '/') return null;

              if (onHome && !showOnHome) return null;

              return (
                <NavLink
                  key={path}
                  to={path}
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ''}`
                  }
                  end={path === '/'}
                >
                  <Text
                    title={title}
                    variant="text-regular-12"
                    className={styles.text}
                  />
                </NavLink>
              );
            })}
          </nav>
        </div>
        <div
          className={`${styles['nav-tools']} ${isRtl ? styles['navigation-rtl'] : ''}`}
        >
          <div>
            <div
              className={`${styles['nav-item']} ${
                !isNormalHeader ? styles['search-white'] : styles['search']
              } ${styles['search-input']}`}
              onClick={() => setSearchOpen(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setSearchOpen(true)}
              dir={isRtl ? 'rtl' : ''}
            >
              <img
                src={searchSvg}
                alt=""
                width={15}
                height={15}
                decoding="async"
              />
              <div className={styles['nav-search']}>
                {isEnglish ? 'Search' : t('common.search')}
              </div>
            </div>
          </div>

          <SearchModal
            isOpen={isSearchOpen}
            onClose={() => setSearchOpen(false)}
            onSearch={(q) => console.log('Search query:', q)}
          />
          <button
            className={styles['nav-item']}
            onClick={() => navigate('/coming-soon')}
          >
            <img src={academy360} alt="Academy 360" decoding="async" />
          </button>
          <button
            className={styles['nav-item']}
            // onClick={() => handleAccessibility()}
            id="accessibility-btn"
          >
            <img
              src={accessibilitySVG}
              alt="Accessibility options"
              decoding="async"
            />
          </button>
          <LanguageToggle
            className={styles['nav-item-en']}
            titleClassname={styles['text-class']}
            isNormalHeader={isNormalHeader}
          />
          <button
            className={styles['nav-item']}
            onClick={() =>
              window.open(
                'https://dubaipolice.ac.ae/dpacademy/ar/std_login.jsp',
                '_blank'
              )
            }
          >
            <Text
              title="home.Sign_In"
              variant="text-regular-14"
              className={styles.signinText}
              color="#1a1a1a"
              svg={loginSvg}
            />
          </button>
        </div>
      </div>
      {isTablet ? (
        <SideModal
          title="navigationMenu.main-menu"
          isbackdropped={false}
          style={{ width: '100%' }}
          isOpenModal={navigationBar}
          className={styles['nav-mobile']}
          titleClassname={styles['title-classname']}
          headerClassname={styles['header-class']}
          contentClassName={styles['content-class']}
          isMobile
          headerComponent={
            <div className={styles['mobile-header']}>
              <img
                src={exitSvg}
                alt="Close menu"
                className={styles['exit']}
                decoding="async"
                onClick={handleOpenNavigator}
              />
              <div className={styles['mobile-right-logo']}>
                <a onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                  <img
                    src={logo}
                    alt="Dubai Police Home"
                    className={styles.logo}
                  />
                </a>
                <img
                  src={logoLine}
                  alt="Separator"
                  className={styles.separator}
                />
                <a
                  href="https://www.dubaipolice.gov.ae/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={dubaiLogo}
                    alt="Dubai Police"
                    decoding="async"
                    loading="eager"
                    className={styles.logo}
                  />
                </a>
              </div>
              <img
                src={searchSvg}
                alt="Open search"
                className={styles['search-svg']}
                decoding="async"
                onClick={() => {
                  handleSearchClick(true);
                  dispatch(closeAllModals());
                }}
              />
            </div>
          }
        >
          <NavigationMobile data={navigatorData} isRtl={isRtl} />
        </SideModal>
      ) : (
        <SideModal
          title="navigationMenu.main_page"
          isbackdropped={false}
          style={{ width: '100%' }}
          isOpenModal={navigationBar}
        >
          <Navigator data={navigatorData} isRtl={isRtl} />
        </SideModal>
      )}

      {isTablet && (
        <SideModal
          title="common.search"
          isbackdropped={true}
          isOpenModal={searchMobileToggle}
          className={styles['accessibility-mobile']}
          onClose={() => handleSearchClick(false)}
          isFromTop
          textColor={isTablet && 'black'}
        >
          <div
            className={styles['search-container']}
            // onMouseEnter={() => (window.isHoveringCalendar = true)}
            // onMouseLeave={() => (window.isHoveringCalendar = false)}
            // onTouchStart={() => (window.isHoveringCalendar = true)}
            // onTouchEnd={() => {
            //   window.isHoveringCalendar = false;
            // }}
          >
            <SearchInput
              inputClassname={styles.input}
              data={RoutesData}
              isNavigation
              hasClear={false}
              isMobile
              textColor={isTablet && 'black'}
            />
          </div>
        </SideModal>
      )}
    </header>
  );
};

export default SiteHeader;
